export function shuffle(l) {
  return l.map(e => [e, Math.random()]).sort((a, b) => a[1] - b[1]).map(e => e[0]);
}
export const STORAGE_KEY = "badminton";